import { styled, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

interface StylesProps {
  hasActionInLeft: boolean;
  hasActionBackground?: boolean;
}

export const DescriptionText = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

const useStyles = ({ hasActionInLeft, hasActionBackground }: StylesProps) =>
  makeStyles((theme: Theme) => ({
    paper: {
      top: "50%",
      left: "50%",
      transform: `translate(-50%, -50%)`,
      position: "absolute",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "8px",
      width: "60vw",
      maxHeight: "90vh",
      overflowY: "auto",
      overflowX: "hidden",
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme?.shadows?.[5] ?? "",
      [theme?.breakpoints?.down("md")]: {
        width: "85vw",
      },
    },
    modalBody: {
      height: "100%",
      width: "100%",
    },
    titleContainer: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
    },
    leftBox: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      alignItems: "flex-start",
    },
    containerLeaveIcon: {
      backgroundColor: "#FEDF89",
    },
    containerConfirmationIcon: {
      backgroundColor: "#A6F4C5",
    },
    containerDeleteIcon: {
      backgroundColor: "transparent",
    },
    containerInfoIcon: {
      backgroundColor: "#D1E9FF",
    },
    containerWarningIcon: {
      backgroundColor: "#FFFAEB",
    },
    containerErrorFoundIcon: {
      backgroundColor: colors.error50,
    },
    containerIcon: {
      borderRadius: "40px",
      alignItems: "center",
      justifyContent: "center",
      height: "40px",
      width: "40px",
      display: "flex",
      marginRight: "10px",
    },
    header: {
      padding: "24px 24px 16px",
    },
    title: {
      fontFamily: "Manrope",
      fontSize: "22px",
      fontWeight: 700,
      lineHeight: "28px",
      fontStyle: "normal",
      color: colors.gray800,
    },
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    statusContainer: {
      display: "flex",
      alignItems: "center",
      marginTop: "24px",
    },
    statusAndBranchContainer: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
    },
    selectBranchContainer: {
      width: "25%",
      marginLeft: "18px",
    },
    modalFooter: {
      borderTop: `1px solid ${colors.gray200}`,
      width: "100%",
      background: hasActionBackground ? colors.white : `#F7F7F9 !important`,
      display: "flex",
      flexDirection: "row",
      justifyContent: hasActionInLeft ? "space-between" : "flex-end",
      padding: hasActionInLeft ? "16px 1.5rem 16px" : "16px 1.5rem 16px 0px",
    },
    select: {
      width: 200,
      marginTop: 10,
    },
    statusFieldTitle: {
      font: "700 18px/18px Manrope",
      color: "#465869",
      marginBottom: 24,
    },
    divider: {
      marginBottom: 24,
    },
    body: {
      padding: "0 1.5rem 1.5rem",
      maxHeight: "calc(90vh - 194px)",
      overflow: "hidden auto",
    },
    bodyWithoutScroll: {
      padding: "0 1.5rem 1.5rem",
      marginTop: 12,
    },
    buttonStatusWrapper: {
      display: "flex",
      alignItems: "center",
      gap: 12,
    },
    buttonStatusLabel: {
      color: "#465869",
      font: "700 14px/21px Manrope",
      marginBottom: 0,
    },
    buttonStatus: {
      borderRadius: 45,
      padding: "12px 20px",
      font: "700 14px/24px Inter",
      display: "flex",
      alignItems: "center",
    },
    buttonActive: {
      backgroundColor: "#D1FADF",
      color: "#32D583",
      border: "1px solid #D1FADF",
    },
    buttonInactive: {
      color: "#F97066",
      backgroundColor: "#FEE4E2",
      border: "1px solid #FEE4E2",
    },
    switchContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      gap: "12px",
    },
    switchTitle: {
      color: "var(--Neutral-Gray-600, #475467)",
      textAlign: "center",
      fontFamily: "Manrope",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.5px",
    },
  }));

export default useStyles;
